import { EntityId } from './entity-id'
import { EntityType } from '../entity-type.models'

export class NotificationID implements EntityId {
  entityType = EntityType.NOTIFICATION
  id: string
  constructor(id: string) {
    this.id = id
  }
}
